import { YouTubeTokenResponse } from "../types/youtube.types";
import { exchangeOAuthCode } from "../../../../../services/oauthTokenExchange";

// These values should be set in your environment or config
const YOUTUBE_CLIENT_ID = process.env.REACT_APP_YOUTUBE_CLIENT_ID || "";
const YOUTUBE_REDIRECT_URI = process.env.REACT_APP_YOUTUBE_REDIRECT_URI || "";

const YOUTUBE_AUTH_BASE_URL = "https://accounts.google.com/o/oauth2/v2/auth";

const YOUTUBE_SCOPE = [
	"https://www.googleapis.com/auth/youtube.readonly",
	"https://www.googleapis.com/auth/youtube.upload",
	"https://www.googleapis.com/auth/userinfo.email",
	"https://www.googleapis.com/auth/userinfo.profile"
].join(" ");

export function getYouTubeAuthUrl(state?: string) {
	if (!YOUTUBE_CLIENT_ID) {
		throw new Error('YouTube Client ID is not configured');
	}

	// No `include_granted_scopes` here on purpose: it makes Google merge every scope
	// this OAuth client was previously granted for the account into this request. Once
	// the same client has a Drive grant (drive.file), the merged request becomes
	// [youtube.readonly, youtube.upload, drive.file] and Google rejects it with
	// "This request contains scopes that cannot be requested together" (error 400
	// invalid_request) — YouTube scopes can't be combined with Drive scopes.
	const params = new URLSearchParams({
		client_id: YOUTUBE_CLIENT_ID,
		redirect_uri: YOUTUBE_REDIRECT_URI,
		response_type: "code",
		access_type: "offline",
		scope: YOUTUBE_SCOPE,
		prompt: "consent",
		...(state ? { state } : {})
	});
	return `${YOUTUBE_AUTH_BASE_URL}?${params.toString()}`;
}

export async function exchangeYouTubeCodeForToken(code: string): Promise<YouTubeTokenResponse> {
	// Exchanged on the server: the client secret never reaches the browser.
	return exchangeOAuthCode<YouTubeTokenResponse>("youtube", code, YOUTUBE_REDIRECT_URI);
}
